import { _ as _defineProperty, a as _objectWithoutProperties, c as classNames } from '../_chunks/dep-27452b12.js';
import * as React from 'react';
import { forwardRef, useMemo, useEffect } from 'react';
import useConfig from '../util/use-config.js';
import useSizeProps from '../util/use-size-props.js';
import { checkScriptAndLoad } from '../util/check-url-and-load.js';
import '../style/css.js';
import '../util/config-context.js';
import '../util/use-common-classname.js';

var _excluded = ["name", "size", "url", "loadDefaultIcons", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CDN_SVGSPRITE_URL = "https://tdesign.gtimg.com/icon/0.0.3/fonts/index.js";
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
      classPrefix = _useConfig.classPrefix;

  var name = props.name,
      size = props.size,
      _props$url = props.url,
      url = _props$url === void 0 ? [] : _props$url,
      _props$loadDefaultIco = props.loadDefaultIcons,
      loadDefaultIcons = _props$loadDefaultIco === void 0 ? true : _props$loadDefaultIco,
      customClassName = props.className,
      customStyle = props.style,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useSizeProps = useSizeProps(size),
      sizeClassName = _useSizeProps.className,
      sizeStyle = _useSizeProps.style;

  var className = useMemo(function () {
    return classNames("".concat(classPrefix, "-icon"), "".concat(classPrefix, "-icon-").concat(name), sizeClassName, customClassName);
  }, [classPrefix, customClassName, name, sizeClassName]);
  useEffect(function () {
    if (typeof document === "undefined") {
      return;
    }

    if (!loadDefaultIcons) {
      return;
    }

    checkScriptAndLoad(CDN_SVGSPRITE_URL, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
  }, [classPrefix, loadDefaultIcons]);
  useEffect(function () {
    var urls = Array.isArray(url) ? url : [url];
    urls.forEach(function (url2) {
      checkScriptAndLoad(url2, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
    });
  }, [classPrefix, url]);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    ref: ref,
    className: className,
    style: _objectSpread(_objectSpread({}, customStyle), sizeStyle)
  }, restProps), /* @__PURE__ */React.createElement("use", {
    xlinkHref: "#t-icon-".concat(name)
  }));
});
Icon.displayName = "Icon";

export { Icon };
//# sourceMappingURL=svg-sprite.js.map
